export default "__VITE_ASSET__CRr$pEWz__"